import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { Box } from "@mui/material";

export default function CustomStepper(props: { type: string; activeStep: number }) {
  const { type, activeStep } = props;
  const smsSteps = ["Verify your number", "Mobile 2FA", "Complete"];
  let getSteps = (type: string) => {
    switch (type) {
      case "sms":
        return smsSteps;
      default:
        return [];
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Stepper activeStep={activeStep} alternativeLabel>
        {getSteps(type).map((label) => (
          <Step
            key={label}
            sx={{
              "& .MuiStepLabel-root .Mui-completed": {
                color: "#4caf50",
                borderRadius: "50%",
              },
              "& .MuiStepLabel-root .Mui-completed.MuiStepLabel-alternativeLabel": {
                color: "#252525",
                border: "none",
              },
              "& .MuiStepLabel-root .Mui-active": {
                color: "#252525",
              },
              "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": {
                color: "#252525", // Just text label (ACTIVE)
              },
              "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                fill: "white", // circle's number (ACTIVE)
              },
            }}
          >
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
